module.exports = __webpack_public_path__ + "static/media/reports_actuary.c9b6a2f3.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/reports_actuary.md
// module id = 1108
// module chunks = 0